import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Grid, Box, withWidth, withStyles } from "@material-ui/core";
import MuiTable from "./MuiTable";

import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import api from 'shared/functions/api/';

const styles = theme => ({
  blogContentWrapper: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(4)
    },
    maxWidth: 1280,
    width: "100%"
  },
  filters: {

  },
  wrapper: {
    minHeight: "60vh",
    paddingTop: 30
  },
});


const PrettoSlider = withStyles({
  root: {
    color: '#52af77',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

function RangeSlider({ classes, label, onChange = (from, to) => { } }) {

  const [value, setValue] = React.useState([20, 70]);

  function valuetext(value) {
    return `${value}°C`;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.filters}>
      <Typography id="range-slider" gutterBottom>
        {label}
      </Typography>
      <PrettoSlider
        value={value}
        onChange={handleChange}
        onMouseUp={e => onChange(value)}
        valueLabelDisplay="auto"
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
      />
    </div>
  );
}

function CertificateButtons({ classes }) {
  const [certificate, setCertificate] = React.useState(null);

  const handleChange = (event, newCertificate) => {
    setCertificate(newCertificate);
  };

  return (<div className={classes.filters}>
    <Typography id="range-slider" gutterBottom>
      Certificates
  </Typography>

    <ToggleButtonGroup size="small" value={certificate} onChange={handleChange}>
      <ToggleButton value="GIA">
        GIA
      </ToggleButton>
      <ToggleButton value="IGI">
        IGI
      </ToggleButton>
      <ToggleButton value="IIDGR">
        IIDGR
      </ToggleButton>
      <ToggleButton value="HRD">
        HRD
      </ToggleButton>
      <ToggleButton value="EGL">
        EGL
      </ToggleButton>
    </ToggleButtonGroup>
  </div>);
}


class Diamonds extends PureComponent {

  state={
    diamondsData: [],
  }

  componentDidMount() {
    const { selectDiamonds = () => { } } = this.props;
    selectDiamonds();
  }

  fetchDiamondsList = async (page = 1, limit = 5, order = 'asc', orderBy = 'createdAt') => {
    const res = await api.get(`/diamonds`, {
      page, 
      limit, 
      order: order === 'asc' ? 1 : -1, 
      sort: orderBy,
    });
    this.setState({ diamondsData: res.data })
  }

  render() {
    const { classes } = this.props;
    const { diamondsData } = this.state;
    return (<React.Fragment>

      <Box
        display="flex"
        justifyContent="center"
        className={classNames(classes.filters, "lg-p-top")}
      >
        <div className={classes.blogContentWrapper}>


          <Grid container justify="center" spacing={10}>
            <Grid key={1} item xs={3}>
              <RangeSlider classes={classes} label={'Weight'} />
            </Grid>
            <Grid key={2} item xs={3}>
              <RangeSlider classes={classes} label={'Colour'} />
            </Grid>
            <Grid key={3} item xs={3}>
              <RangeSlider classes={classes} label={'Clarity'} />
            </Grid>
            <Grid key={4} item xs={3}>
              <CertificateButtons classes={classes} />
            </Grid>
          </Grid>

        </div>
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        className={classes.wrapper}
      >
        <div className={classes.blogContentWrapper}>
          <Grid container spacing={3}>
            <MuiTable fetchDiamondsList={this.fetchDiamondsList} diamondsData={diamondsData} />
          </Grid>
        </div>
      </Box>
    </React.Fragment>);
  }
}

Diamonds.propTypes = {
  selectDiamonds: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  diamondsData: PropTypes.arrayOf(PropTypes.object)
};

export default withWidth()(withStyles(styles, { withTheme: true })(Diamonds));
